import React from "react";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import classes from './datePicker.module.scss'

const DatePicker = ({ placeholder, name, item, onChangeHandler, index, parentData, value })=>{
    return (
        <div>
            <DayPickerInput
                dayPickerProps={{
                    month: item?.minimum_value ? new Date(item?.minimum_value) : new  Date(),
                    disabledDays: {
                        after: new Date(item?.maximum_value),
                        before: new Date(item?.minimum_value),
                    },
                    selectedDays: value ? new Date(value) : item?.minimum_value?new Date(item?.minimum_value):new Date(),
                }}
                initialFocus={true}
                className={classes.date_picker_styling}
                placeholder={placeholder+" (YYYY-MM-DD)"}
                onDayChange={(value) => onChangeHandler(value, item, index, parentData)} />
            
        </div>
    );
}

export default DatePicker;
